import { DateTime } from "luxon";

import {
  CampaignFieldsForEditorFragment,
  CampaignFieldsForViewFragment,
} from "~frontend/__generated__/graphql";

export default function determineFilename(
  contactImportJob:
    | CampaignFieldsForViewFragment["contactImportJob"]
    | CampaignFieldsForEditorFragment["contactImportJob"]
    | null
    | undefined
): string {
  switch (contactImportJob?.__typename) {
    case "CampaignContactUploadJob":
      return contactImportJob.args.upload.fileName ?? "unknown file";
    case "CampaignContactActionKitImportJob":
      return contactImportJob.args.reportShortName
        ? `ActionKit report "${contactImportJob.args.reportShortName}"`
        : "unknown report";
    case "CampaignContactGCSImportJob":
      return contactImportJob.args.objectName
        ? `GCS File "${contactImportJob.args.objectName}"`
        : "unknown file";
    case "CampaignContactActBlueImportJob":
      if (
        contactImportJob.args.reportStartDate &&
        contactImportJob.args.reportEndDate
      ) {
        const formatedStartDate = DateTime.fromISO(
          contactImportJob.args.reportStartDate
        ).toFormat("MMMM dd, yyyy");
        const formatedEndDate = DateTime.fromISO(
          contactImportJob.args.reportEndDate
        ).toFormat("MMMM dd, yyyy");

        return `ActBlue between ${formatedStartDate} and ${formatedEndDate}`;
      }
      return "unknown";
    case "CampaignContactFollowUpImportJob":
      return "followed-up campaigns";
    case "CampaignContactNgpVanImportJob":
      return contactImportJob?.result?.sourceList
        ? `VAN list "${contactImportJob.result.sourceList.listName}" (ID: ${contactImportJob.result.sourceList.savedListId})`
        : "NGPVAN / EveryAction";
    case "CampaignContactSubscriberImportJob":
      return "Subscribers";
    case "CampaignContactAudienceImportJob":
      return contactImportJob.args.audienceName || "Subscribers";
    case null:
    case undefined:
    case "CampaignContactImportJob": // This shouldn't ever be returned as a __typename
      return "unknown";
    default:
      contactImportJob satisfies never;
      return "unknown";
  }
}
